import { Box } from '@chakra-ui/react'
import { PropsWithChildren, Suspense } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { routes } from '~constants/routes'
import { AllocationRoutes } from '~features/allocation'
import { CampaignCreationRoute } from '~features/campaign/routes'
import { DistributionRoutes } from '~features/distribution'
import { DistributorRoutes } from '~features/distributor'
import { LocationRoutes } from '~features/location'
import { SettingRoutes } from '~features/setting'
import { StatisticsRoutes } from '~features/statistics'
import { lazyImport } from '~utils/lazyImport'

const { AuthRoutes } = lazyImport(() => import('~features/auth'), 'AuthRoutes')
const { DashboardRoutes } = lazyImport(
  () => import('~features/dashboard'),
  'DashboardRoutes',
)
const { HealthRoutes } = lazyImport(
  () => import('~features/health'),
  'HealthRoutes',
)

const router = createBrowserRouter([
  {
    path: routes.index,
    element: <DashboardRoutes />,
  },
  {
    path: routes.createCampaign,
    element: <CampaignCreationRoute />,
  },
  {
    path: routes.login,
    element: <AuthRoutes />,
  },
  {
    path: routes.health,
    element: <HealthRoutes />,
  },
  {
    path: routes.allocation,
    element: <AllocationRoutes />,
  },
  {
    path: routes.distribution,
    element: <DistributionRoutes />,
  },
  {
    path: routes.statistics,
    element: <StatisticsRoutes />,
  },
  {
    path: routes.location,
    element: <LocationRoutes />,
  },
  {
    path: routes.distributor,
    element: <DistributorRoutes />,
  },
  {
    path: routes.settings,
    element: <SettingRoutes />,
  },
  {
    path: '*',
    element: <div>404</div>,
  },
])

const WithSuspense = ({ children }: PropsWithChildren) => (
  <Suspense fallback={<Box bg="neutral.100" minH="$100vh" w="100vw" />}>
    {children}
  </Suspense>
)

export const AppRouter = (): JSX.Element => {
  return (
    <WithSuspense>
      <RouterProvider router={router} />
    </WithSuspense>
  )
}
